module.exports = __webpack_public_path__ + "6ad0c760.svg";